<template>
  <div class="file-body">
    <div
      class="file-list"
      v-for="(item, index) in fileList"
      :key="index"
    >
      <div class="left form-bag">
        <div class="ly-c-flex">
          <img
            class="file-img"
            :src="getFileType(item)"
          />
          <div class="name-content">
            <div class="name">
              <text-tooltip
                :content="getName(item)"
                :size="getSize(item)"
                class="file-name"
              />
              <!-- <div class="size">({{ getSize(item) }})</div> -->
            </div>
          </div>
        </div>
        <div
          class="user-info"
          v-if="item[listParams.userName]"
        >
          {{ item[listParams.userName] }}
          上传于 {{ item[listParams.time] }}
        </div>

        <div
          class="version"
          v-if="getVersion(item)"
        >
          {{ getVersion(item) }}
        </div>
      </div>
      <div class="right ly-c-flex">
        <div class="btn">
          <el-tooltip
            class="item"
            effect="dark"
            content="下载"
            placement="top"
            v-if="item.uuid"
          >
            <svg-icon
              class="pointer"
              icon-class="icon_download"
              @click="handleDownloadFile(item)"
            ></svg-icon>
          </el-tooltip>
        </div>
        <div class="btn">
          <el-tooltip
            class="item"
            effect="dark"
            content="预览"
            placement="top"
            v-if="item.uuid"
          >
            <svg-icon
              class="pointer"
              icon-class="icon_view"
              @click="previewFile(item)"
            ></svg-icon>
          </el-tooltip>
        </div>
        <div
          class="btn"
          v-if="type !== 'view' && !item.isHistory"
        >
          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <svg-icon
              class="pointer"
              :icon-class="btnIcons.del"
              @click="handleDeleteFile(item, index)"
            ></svg-icon>
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../../scripts/utils";
import request from "../../scripts/request";
import TextTooltip from "../TextTooltip";
export default {
  components: { TextTooltip },
  name: "",
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    downloadUrl: {
      type: String,
      default: "",
    },
    previewUrl: {
      type: String,
      default: "",
    },
    fileParams: {
      type: Object,
      default: () => {
        return null;
      },
    },
    type: {
      //用于判断是否禁用，或只显示文件列表
      type: String,
      default: "",
    },
    versionType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      fileList: this.value,
      listParams: {
        name: "name",
        size: "size",
        userName: "userName",
        time: "uploadTime",
        versionType: "versionType",
        delKey: "uuid",
      },
      fileType: {
        word: ["doc", "docx"],
        excel: ["xls", "xlsx"],
        pdf: ["pdf"],
        ppt: ["ppt", "pptx"],
        // rar: ["rar", "zip"],
        png: ["png", "jpg", "svg"],
      },
    };
  },
  watch: {
    fileParams: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.listParams = {
            ...this.listParams,
            ...val,
          };
        }
      },
    },
    value: {
      deep: true,
      immediate: true,
      handler(val) {
        this.fileList = val;
      },
    },
  },
  created() {},
  mounted() {},
  methods: {
    getName(item) {
      let name = "";
      let nameParams = this.listParams.name;
      if (item[nameParams]) {
        name = item[nameParams];
      } else {
        name = item.fileName + item.fileType;
      }
      return name;
    },
    getSize(item) {
      let size = item[this.listParams.size] || item.fileSize;
      return utils.getSize(size);
    },
    getVersion(item) {
      let version = "";
      let versionParams = this.listParams.versionType;
      version =
        item[versionParams] != undefined
          ? item[versionParams]
          : this.versionType;
      return version;
    },
    /**获取图标类型 */
    getFileType(file) {
      let name = file.name;
      let fileType = file.fileType || this.getSuffix(name);
      let type = "other";
      let typeName = fileType.replace(".", "");
      for (let key in this.fileType) {
        if (this.fileType[key].includes(typeName)) {
          type = key;
        }
      }
      return require("@/assets/images/icon_" + type + ".svg");
    },
    /**获取文件名后缀 */
    getSuffix(filename) {
      if (!filename) return "other";
      const pos = filename.lastIndexOf(".");
      let suffix = "";
      if (pos != -1) {
        suffix = filename.substring(pos);
      }
      return suffix.toLocaleLowerCase();
    },
    /**删除 */
    handleDeleteFile(item, index) {
      this.fileList.splice(index, 1);
      this.$emit("input", this.fileList, "delete");
      this.$emit("delete", item, this.fileList);
    },
    /**预览 */
    previewFile(row) {
      let uuid = row[this.listParams.delKey] || row["uuid"];
      if (this.previewUrl) {
        request({
          url: this.previewUrl + uuid,
          method: "get",
        }).then((res) => {
          if (res.code === "00000") {
            // if (res.data) {
            //   window.open(res.data);
            // }
            let newUrl = res.data; // 公网替换
            if (newUrl.indexOf("open.sinochem.com") > -1) {
              newUrl = res.data.replace(
                "open.sinochem.com",
                "mobile.sinochem.com"
              );
            }
            window.open(newUrl);
          }
        });
      }
    },
    /**下载 */
    handleDownloadFile(row) {
      let uuid = row[this.listParams.delKey] || row["uuid"];
      if (this.downloadUrl) {
        request({
          url: this.downloadUrl + uuid,
          method: "get",
          responseType: "blob",
        }).then((res) => {
          if (!res) return;
          utils.fileDownload(res, row.name);
        });
      } else if (row.downLoadUrl) {
        const link = document.createElement("a");
        link.href = row.downLoadUrl;
        link.download = row.name;
        link.click();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.file-body {
  // margin-top: 12px;
}
.file-list {
  width: 100%;
  position: relative;
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  background-color: #f3f5f9;
  border-radius: 6px;
  .left {
    flex: 1;
    flex-grow: 1;
    position: relative;
    overflow: hidden;
    .ly-c-flex {
      width: 100%;
      padding: 8px 12px;
    }
    .file-img {
      width: 16px;
      height: auto;
      margin-right: 8px;
    }
    .name-content {
      width: calc(100% - 40px);
    }

    .name {
      display: flex;
      align-items: center;
      .file-name {
        display: inline-block;
        width: calc(100% - 80px);
        font-size: 14px;
        color: $fontColor;
      }
      .size {
        font-size: 12px;
        color: #898b9b;
        display: inline-block;
        margin-left: 16px;
      }
    }

    .version {
      background: $primaryColor;
      border-radius: 0px $borderRadius 0px $borderRadius;
      position: absolute;
      top: 0;
      right: 0;
      padding: 0px 8px;
      font-size: 12px;
      min-width: 48px;
      text-align: center;
      height: 16px;
      line-height: 16px;

      font-size: 11px;
      color: #ffffff;
    }

    .file-progress {
      position: absolute;
      width: 100%;
      left: 11px;
      bottom: 0;
      line-height: 2px;

      .el-progress-bar {
        padding-right: 23px;
      }

      .el-progress__text {
        display: none;
      }

      .el-progress-bar__outer {
        height: 2px !important;
        background-color: rgba(44, 75, 211, 0.16);
      }
    }
    .user-info {
      background: $file_content;
      padding: 6px 12px;
      font-size: 12px;
      color: #58636e;
    }
  }
  .right {
    margin-left: 16px;
    padding: 8px 0;
    padding-right: 25px;
    .btn {
      cursor: pointer;
      margin-right: 12px;
      .el-button--text {
        color: #44464e;
      }
      .el-button--default {
        font-size: 20px;
      }
    }
  }
  .delIcon {
    margin-left: 10px;
    color: #a6a6a6;

    .svg-icon {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
